module.exports = __webpack_public_path__ + "35dc9076b5759eeded737efb2d3604c6.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/stones-throw.svg
 ** module id = 439
 ** module chunks = 0
 **/